export default __webpack_public_path__ + "static/media/invoice.2da6a4a6.svg";